export const MODAL_NAME = 'orders.orderline.add-imei'
export const FORM_ID = 'orders.orderline.add-imei'

export const IMEI_MAX_LENGTH = 15

export const INITIAL_VALUES = {
  imei: '',
}
